import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { GET_CHATS_BY_FILTERS, type ChatAppType } from '../queries/chats';
import { MARK_CHAT_AS_READ } from '../queries/mutations';
export function useMarkChatAsRead(userUuid, appType) {
  const $ = _c(5);
  let t0;
  if ($[0] !== appType || $[1] !== userUuid) {
    t0 = {
      refetchQueries: userUuid ? [{
        query: GET_CHATS_BY_FILTERS,
        variables: {
          userUuid,
          appType
        }
      }] : [],
      awaitRefetchQueries: false
    };
    $[0] = appType;
    $[1] = userUuid;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [markChatAsReadMutation] = useMutation(MARK_CHAT_AS_READ, t0);
  let t1;
  if ($[3] !== markChatAsReadMutation) {
    t1 = async chatUuid => {
      ;
      try {
        await markChatAsReadMutation({
          variables: {
            chatUuid
          }
        });
      } catch (t2) {
        const error = t2;
      }
    };
    $[3] = markChatAsReadMutation;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const markChatAsRead = t1;
  return markChatAsRead;
}